import {
    IGestaoDeVisitasBody,
    IGestaoDeVisitasPonto,
    IGestaoDeVisitasResponse,
} from "../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import {
    AtualizarPontoDeVendaService,
    CadastrarPontoDeVendaService,
    DeletarPontoDeVendaService,
    EfetivarVisitarVendasService,
    GestaoDeVisitaServices,
    ListarHorariosAgendadosPontoVendaService,
    ListarPontosDeVendaServices,
    ListarPontoVendasDisponivelService,
} from "../../../Services/Vendas/GestaoDeVisitas/GestaoDeVisitaServices";
import { Controller } from "../../Controller";

export async function GestaoDeVisitaVendasController(
    pagina: number,
    responseBody: IGestaoDeVisitasBody
) {
    return Controller(
        GestaoDeVisitaServices<IGestaoDeVisitasResponse>(
            pagina,
            responseBody,
            0
        )
    );
}
export async function ExportarGestaoDeVisitaVendasController(
    requestBody: IGestaoDeVisitasBody
    // pagina: number
) {
    return Controller(GestaoDeVisitaServices<Blob>(0, requestBody, 1));
}

export async function ListarPontosDeVendaController() {
    return Controller(ListarPontosDeVendaServices());
}

export async function CadastrarPontoDeVendaController(
    requestBody: IGestaoDeVisitasPonto
) {
    return Controller(CadastrarPontoDeVendaService(requestBody));
}

export async function AtualizarPontoDeVendaController(
    requestBody: IGestaoDeVisitasPonto
) {
    return Controller(AtualizarPontoDeVendaService(requestBody));
}

export async function DeletarPontoDeVendaController(ID_PONTO_VENDA: number) {
    return Controller(DeletarPontoDeVendaService(ID_PONTO_VENDA));
}

export async function ListarHorariosAgendadosPontoVendaController(
    DATA: string,
    ID_CASO: number
) {
    return Controller(ListarHorariosAgendadosPontoVendaService(DATA, ID_CASO));
}

export const ListarPontoVendasDisponivelController = async (
    DATA: string,
    HORARIO: string
) => {
    return Controller(ListarPontoVendasDisponivelService(DATA, HORARIO));
};

export async function EfetivarVisitarVendasController(
    ID_VISITA: number,
    FL_EFETIVAR: boolean
) {
    return Controller(EfetivarVisitarVendasService(ID_VISITA, FL_EFETIVAR));
}
